import { Injectable } from '@angular/core'
import BaseService from '@ui/Services/BaseService'

@Injectable()
export class AppService extends BaseService<any> {
	constructor() {
		super()
	}
}
